import { render, staticRenderFns } from "./ReportFormPersonalData.vue?vue&type=template&id=1a431c86"
import script from "./ReportFormPersonalData.vue?vue&type=script&lang=ts"
export * from "./ReportFormPersonalData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports